import { render, staticRenderFns } from "./ModalEditarGrupo.vue?vue&type=template&id=3a33f35b"
import script from "./ModalEditarGrupo.vue?vue&type=script&lang=js"
export * from "./ModalEditarGrupo.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarGrupo.vue?vue&type=style&index=0&id=3a33f35b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports